import { APIS, fullPath } from 'services/shared/routerService';
import { HTTP_METHODS } from 'services/shared/HTTPService';
import { handleErrors } from 'services/shared/clientService';
import { PurchaseCreateInterface } from 'schemas/purchaseCreateSchema';
import { PurchaseCancelInterface } from 'schemas/purchaseCancelSchema';

export const DEFAULT_PURCHASES_PER_PAGE = 20;

export const createPurchase = async (data: PurchaseCreateInterface, isSystem = false) => {
	const headers: HeadersInit = { 'Content-Type': 'application/json' };
	if (isSystem) {
		headers['system-token'] = process.env.NEXTAUTH_SECRET || '';
	}

	const response = await fetch(fullPath(APIS.PURCHASE_CREATE), {
		method: HTTP_METHODS.POST,
		body: JSON.stringify(data),
		credentials: 'include',
		headers,
	});
	const responseJSON = await response.json();
	await handleErrors(response, responseJSON);

	return responseJSON;
};

export const cancelPurchase = async (data: PurchaseCancelInterface) => {
	const response = await fetch(fullPath(APIS.PURCHASE_CANCEL), {
		method: HTTP_METHODS.POST,
		body: JSON.stringify(data),
		credentials: 'include',
		// headers: { 'Content-Type': 'application/json' },
	});
	const responseJSON = await response.json();
	await handleErrors(response, responseJSON);

	return responseJSON;
};
